import customHeaders, { getSpace } from '../../../../common/headers';
import { useNavigate } from 'react-router-dom';
import { ModalCoverProject } from './ModalCoverProject/ModalCoverProject';
import { useState, useEffect } from 'react';
import { RavshanHttps } from '../../../../fetchUrls';
import {
  InputDinamycPlaceholder,
  ButtonBasic,
  SelectExecutor,
  TextareaDynamicPlaceholder,
  DropDownSelector
} from '@lk-gtcom/ecomlab-components';
import { ButtonWithIcon } from '../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { DynamicFormComponent } from '../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalAddElementsDict } from './ModalAddElementsDict/ModalAddElementsDict';
import { ExecutorPlaceholder } from '../../../../components/OptionsExecutor/OptionsExecutor';
import { ButtonActionDrop } from '../../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import { TabsGreen } from '../../../../components/TabsGreen/TabsGreen';
import useGeneralStore from '../../../../store/general';
import { TitlePage } from '../../../../components/TitlePage/TitlePage';
import { useLocation } from 'react-router-dom';
import { ModalAlert } from '../../../../components/Modal/ModalAlert/ModalAlert';
import './ModalAddProject.scss';
import no_photo from './img/not-img.svg';
import { periodWeek } from '../../../../common/constant';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';
import { useResponseHandler } from '../../../../common/auth';
import { usePushNotifications } from '../../../../common/pushNotification';

const TYPE_LIST = [
  { label: 'Строка', value: 'string' },
  { label: 'Чекбокс', value: 'bool' },
  { label: 'Число', value: 'int' },
  { label: 'Дробное число', value: 'float' },
  { label: 'Список с выбором значений', value: 'dict' },
  { label: 'Проценты', value: 'percent' },
  { label: 'Теги', value: 'array' },
  { label: 'Поле ввода для текста', value: 'field' },
]

const ModalAddProject = ({
  setIsModal,
  isInfoProject,
  setIsInfoProject,
  selectedProject,
  ticket = false,
  crm = false,
  task = false
}) => {

  const btns_tab_crm = [
    { label: 'Получение токена', value: 'token' }
  ]

  const btns_tab_task = [
    { label: 'Добавить wiki', value: 'wiki' }
  ]

  const btns_tab = [
    { label: 'Общая информация', value: 'info' },
    { label: 'Участники и заявки', value: 'exexutors' },
    { label: 'Создание полей', value: 'fields' },
    ...crm ? btns_tab_crm : [],
    ...task ? btns_tab_task : []
  ];

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  // Обработка ошибок
  const { addErrorPush, addSuccessPush } = usePushNotifications();

  const navigate = useNavigate();
  const location = useLocation();
  const cleanUrl = location.pathname;

  const [executors, setExecutors] = useState([]);
  const [executorOptions, setExecutorOptions] = useState([]);
  const [date, setDate] = useState(periodWeek());
  const [defaultDate, setDefaultDate] = useState(periodWeek());
  const [isEdit, setIsEdit] = useState(false);
  const [infoProject, setInfoProject] = useState(null)

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [authorName, setAuthorName] = useState('');
  const [authorEmail, setAuthorEmail] = useState('');
  const [authorColor, setAuthorColor] = useState('');
  const [isFavorite, setIsFavorite] = useState(false);
  const [isPin, setIsPin] = useState(false);
  const [currentCover, setCurrentCover] = useState(null);

  const [isModalAddCover, setIsModalAddCover] = useState(false);
  const [status, setStatus] = useState(btns_tab?.[0]?.value);

  const [wikiList, setWikiList] = useState([])
  const [selectedWiki, setSelectedWiki] = useState({})

  // Поля 
  const [selectedType, setSelectedType] = useState(TYPE_LIST[0])
  const [fieldsdName, setFieldsName] = useState('')
  const [fields, setFilds] = useState([])
  const [listDict, setListDict] = useState([])

  // Модалка
  const [isModalAddElementsDict, setIsModalAddElementsDict] = useState(false)
  const [isModalAlert, setIsModalAlert] = useState(false)


  // Токен
  const [tokenProject, setTokenProject] = useState(null)
  const [initialTime, setInitialTime] = useState(true)

  // new logic
  const [projectId, setProjectId] = useState(null)

  // ПОЛУЧЕНИЕ ПАРАМЕТРОВ ///////////////////////////////////////////////////////////////

  // Получить список wiki
  // не нужно
  const fetchWikiList = () => {
    const url = `${RavshanHttps}/api/v2/article/wiki/get?type_project=false`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(json => {
        const current_list = json?.map(({ id, name }) => ({ label: name, value: id }))
        setWikiList(current_list)
      })
      .catch(handleRequestError)
  }

  // Привязать wiki к проекту
  const fetchBindWiki = () => {
    let url = `https://portals.ecomru.ru/api/v3/tasks/bind_wiki`

    const body = JSON.stringify({
      project_id: selectedProject?.taskId,
      wiki_id: selectedWiki?.value || null
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .catch((err) => console.error(err));
  };

  // Добавление полей
  const addFields = (fieldsdName) => {
    fetchAddAdditionalFieldsProject(fieldsdName)
    setFieldsName('');
  };

  // Получение полей
  const fetchGetAdditionalFields = (
    abortController = new AbortController()
  ) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/get_additional_field/${selectedProject?.taskId || projectId}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/get_additional_field/${selectedProject?.taskId || projectId}`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/get_additional_field/${selectedProject?.taskId || projectId}`
    }

    fetch(url, { method: 'GET', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        if (json) {
          setFilds(json?.map(({ name, id, type, possible_values, before }) => ({ front_name: name, data_type: type, id: id, possible_values, before })))
        }
      })
      .catch(handleRequestError);
  };

  // Добавление доп полей к проекту
  const fetchAddAdditionalFieldsProject = (name) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/create_additional_field`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/create_additional_field`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/create_additional_field`
    }

    const body = JSON.stringify({
      project_id: selectedProject?.taskId || projectId,
      name: name,
      type: selectedType?.value,
      possible_values: listDict,
      before: null
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then(json => {
        setTimeout(() => fetchGetAdditionalFields(), 500)
        setListDict([])
      })
      .catch(handleRequestError);
  };

  // Изменение доп полей к проекту
  const fetchChangeAdditionalFieldsProject = (name, id, type, before = null, possible_values) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/update_additional_field`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/update_additional_field`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/update_additional_field`
    }

    const body = JSON.stringify({
      project_id: selectedProject?.taskId || projectId,
      name: name,
      type: type,
      field_id: id,
      before,
      possible_values
    });

    fetch(url, { method: 'PATCH', headers, body })
      .then(handleTableResponse)
      .then(() => setTimeout(() => fetchGetAdditionalFields(), 500))
      .catch(handleRequestError);
  };

  // Удаление поля
  const fetchDeleteAdditionalFieldsProject = (id) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/delete_additional_field/${id}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/delete_additional_field/${id}`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/delete_additional_field/${id}`
    }

    fetch(url, { method: 'DELETE', headers })
      .then(handleTableResponse)
      .then(() => setTimeout(() => fetchGetAdditionalFields(), 500))
      .catch(handleRequestError);
  };

  useEffect(() => {
    if (selectedProject?.taskId) {
      fetchWikiList()
    }
  }, []);


  // Получение информации по проекту
  const fetchGetInfoProject = () => {

    let url = `https://portals.ecomru.ru/api/crm/projects/${selectedProject?.taskId || projectId}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/${selectedProject?.taskId || projectId}`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/${selectedProject?.taskId || projectId}`
    }

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(json => setInfoProject(json))
      .catch(handleRequestError);
  };

  // Создание проекта
  // Done
  const fetchCreateProject = () => {
    if (selectedProject?.taskId) return
    let url = `https://portals.ecomru.ru/api/crm/projects/`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/create_project`
    }

    fetch(url, { method: 'POST', headers })
      .then(handleTableResponse)
      .then(json => setProjectId(json))
      .catch(handleRequestError);
  };

  // Добавить название проекта
  const fetchAddNameProject = () => {
    let url = `https://portals.ecomru.ru/api/crm/projects/name`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/name`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_project_name`
    }

    const body = JSON.stringify({
      name: title,
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId
    });

    fetch(url, { method: task ? 'POST' : 'PATCH', headers, body })
      .then(handleTableResponse)
      .then(() => console.log('Название проекта сохранено'))
      .catch(handleRequestError);
  };

  // Добавить описание проекта
  const fetchAddDescriptionProject = () => {
    let url = `https://portals.ecomru.ru/api/crm/projects/description`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/description`
    }
    if (task) {
      url = ` https://portals.ecomru.ru/api/v3/tasks/set_description`
    }

    const body = JSON.stringify({
      description: description,
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId
    });

    fetch(url, { method: task ? 'POST' : 'PATCH', headers, body })
      .then(handleTableResponse)
      .then(() => console.log('Описание проекта сохранено'))
      .catch(handleRequestError);
  };

  // Добавить изображение проекта
  const fetchAddImageProject = (img) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/image`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/image`
    }
    if (task) {
      url = ` https://portals.ecomru.ru/api/v3/tasks/set_image`
    }

    const body = JSON.stringify({
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId,
      [task ? 'image_url' : 'image']: img
    });

    fetch(url, { method: task ? 'POST' : 'PATCH', headers, body })
      .then(handleTableResponse)
      .then(() => console.log('Изображение проекта сохранено'))
      .catch(handleRequestError);
  };

  useEffect(() => {
    if (infoProject?.id) {
      const {
        name,
        attendee,
        author,
        description,
        start_time,
        end_time,
        image,
        wiki,
        is_favorite,
        is_pin
      } = infoProject;

      setIsInfoProject(selectedProject);
      if (name) {
        setTitle(name)
      }
      if (description) {
        setDescription(description)
      }
      if (image) {
        setCurrentCover(image)
      }
      setIsFavorite(is_favorite || false);
      setIsPin(is_pin || false);
      if (author) {
        const { name, login, color } = author;
        setAuthorColor(color);
        setAuthorEmail(login);
        setAuthorName(name);
      }
      if (start_time && end_time) {
        setDefaultDate([
          new Date(start_time),
          new Date(end_time),
        ]);
      }
      if (wiki) {
        setSelectedWiki({
          label: wiki?.name,
          value: wiki?.id
        })
      }
    }

  }, [infoProject]);

  // Добавить дату проекта
  // Не верная дата
  const fetchSetTimeProject = () => {
    let url = ` https://portals.ecomru.ru/api/v3/tasks/set_times`

    const [date_from, date_to] = date;

    const body = JSON.stringify({
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId,
      start_time: new Date(date_from),
      end_time: new Date(date_to)
    });

    fetch(url, { method: task ? 'POST' : 'PATCH', headers, body })
      .then(handleTableResponse)
      .then(() => console.log('Дата проекта сохранена'))
      .catch(handleRequestError)
  };

  // Добавить участников в проект
  const fetchAddAttendeeProject = (executor) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/attendee/add`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/attendee/add`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/add_attendee`
    }

    const body = JSON.stringify({
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId,
      [task ? 'client_id' : 'attendee_id']: executor,
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then(() => console.log('Участник успешно добавлен'))
      .catch(handleRequestError);
  };

  // Удалить участников из проекта
  const fetchDeleteAttendeeProject = (executor) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/attendee/remove`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/attendee/remove`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/remove_attendee`
    }

    const body = JSON.stringify({
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId,
      [task ? 'client_id' : 'attendee_id']: executor,
    });

    fetch(url, { method: 'DELETE', headers, body })
      .then(handleTableResponse)
      .then(() => console.log('Участник успешно удален'))
      .catch(handleRequestError);
  };

  // Добавить в избранное CRM
  const fetchAddFavoriteProject = (is_favorite) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/{project_id}/favorite`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/{project_id}/favorite`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/project/favorite`
    }

    const body = JSON.stringify({
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId,
      is_favorite: is_favorite,
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then(() => addSuccessPush(`Проект "${title}" ${is_favorite ? 'добавлен в избранное' : 'удален из избранного'}`))
      .catch((err) => console.error(err));
  };

  // Добавить в закрепленное CRM
  const fetchAddPinProject = (is_pin) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/{project_id}/pin`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/{project_id}/pin`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/project/pin`
    }

    const body = JSON.stringify({
      project_id: selectedProject?.taskId ? selectedProject?.taskId : projectId,
      is_pin: is_pin,
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then(() => addSuccessPush(`Проект "${title}" ${is_pin ? 'добавлен в закрепленные' : 'удален из закрепленных'}`))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (!initialTime) {
      fetchSetTimeProject()
    }
  }, [date]);

  useEffect(() => {
    fetchCreateProject()
  }, []);

  // Удаление проекта
  const deleteProject = (id) => {
    let url = `https://portals.ecomru.ru/api/crm/projects/${id}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/${id}`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/${id}`;
    }

    fetch(url, { method: 'DELETE', headers })
      .then((res) => {
        if (res.ok) {
          addSuccessPush(`Проект ID-${id} успешно удален`)
          console.log(`Проект ID-${id} успешно удален`)
          setIsModal(false);
          sessionStorage.removeItem('selectedProject');
        } else {
          throw new Error('bad post project response');
        }
      })
      .catch(handleRequestError);
  };

  // Получение токена проекта
  const fetchGetToken = (id) => {
    let url = ` https://portals.ecomru.ru/api/crm/projects/token/${id}`
    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(json => {
        if (json) {
          setIsModalAlert(true)
          setTokenProject(json)
        }
      })
      .catch(handleRequestError)
  }

  const fetchPossibleAttendees = () => {
    let url = `https://portals.ecomru.ru/api/crm/projects/${selectedProject?.taskId || projectId}/attendees?can_be_add=true`;
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/${selectedProject?.taskId || projectId}/attendees?can_be_add=true`;
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/${selectedProject?.taskId || projectId}/attendees?can_be_add=true`
    }

    fetch(url, { headers })
      .then(handleTableResponse)
      .then((json) => {
        setExecutorOptions(
          json?.filter((e) => {
            const nameLowerCased = e.name.toLowerCase();
            return !executors
              ?.map((e) => e.name.toLowerCase())
              .includes(nameLowerCased);
          })
        );
      })
      .catch(handleRequestError);
  };

  const fetchPossibleAttendeesAdded = () => {
    let url = `https://portals.ecomru.ru/api/crm/projects/${selectedProject?.taskId || projectId}/attendees?can_be_add=false`;
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/${selectedProject?.taskId ? selectedProject?.taskId : projectId}/attendees?can_be_add=false`;
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/${selectedProject?.taskId || projectId}/attendees?can_be_add=false`
    }

    fetch(url, { headers })
      .then(handleTableResponse)
      .then((json) => {
        setExecutors(
          json?.filter((e) => {
            const nameLowerCased = e.name.toLowerCase();
            return !executors
              ?.map((e) => e.name.toLowerCase())
              .includes(nameLowerCased);
          })
        );
      })
      .catch(handleRequestError);
  };

  const btns = [
    {
      btn: 'Получить токен',
      func: () => fetchGetToken(projectId || selectedProject?.taskId),
    },
    {
      btn: 'Удалить',
      func: () => deleteProject(projectId || selectedProject?.taskId),
    },
  ];

  useEffect(() => {
    if (selectedProject || projectId) {
      fetchPossibleAttendees();
      fetchPossibleAttendeesAdded()
    }
    if (isInfoProject) {
      setIsInfoProject(selectedProject);
    }
  }, [isInfoProject, selectedProject, projectId]);

  useEffect(() => {
    if (selectedProject) {
      setIsEdit(true);
    }
  }, [selectedProject]);

  useEffect(() => {
    return () => {
      setIsInfoProject(null);
    };
  }, []);

  useEffect(() => {
    if (projectId || selectedProject) {
      fetchGetAdditionalFields();
      fetchGetInfoProject()
      fetchWikiList()
    }
  }, [projectId, selectedProject]);


  return (
    <>
      {isModalAlert && <ModalAlert
        title={tokenProject}
        copy={true}
        setIsModal={setIsModalAlert}
      />}

      {isModalAddElementsDict &&
        <ModalAddElementsDict
          list={listDict}
          setList={setListDict}
          setIsModal={setIsModalAddElementsDict}
        />}

      {isModalAddCover &&
        <ModalCoverProject
          setIsModal={setIsModalAddCover}
          currentCover={currentCover}
          setCurrentCover={setCurrentCover}
          fetchAddImageProject={fetchAddImageProject}
        />
      }

      <ModalComponent
        title={isEdit ? `Редактирование проекта "${title}"` : 'Создание проекта'}
        onClose={(e) => {
          setIsEdit(false);
          setIsModal(false);
          if (!title) {
            deleteProject(projectId || selectedProject?.taskId);
          }
          sessionStorage.removeItem('selectedProject');
          if (crm) {
            navigate(`/crm/project-for-crm/project`);
          }
          if (task) {
            navigate(`/tasks/project-for-tasks`);
          }
          if (ticket) {
            navigate(`/ticket/project-for-ticket`);
          }
        }}
        style={{
          maxWidth: '1100px',
          minHeight: '700px',
          height: 'auto'
        }}
        childHeader={
          <div className="modal-add-project__header">

            <ButtonWithIcon
              pin
              whiteGreen
              style={{ marginLeft: 'auto' }}
              changeValue={isPin}
              size='m'
              onClick={(e) => {
                setIsPin(!isPin)
                fetchAddPinProject(!isPin)
              }}
            />

            <ButtonWithIcon
              favorite
              whiteGreen
              changeValue={isFavorite}
              size='m'
              onClick={(e) => {
                setIsFavorite(!isFavorite)
                fetchAddFavoriteProject(!isFavorite)
              }}
            />

            <ButtonActionDrop
              id={1}
              btns={btns}
            />
          </div>
        }
        child={
          <div className="modal-add-project">
            <TabsGreen
              btns={btns_tab}
              currentBtn={status}
              setCurrentBtn={(e) => setStatus(e)}
              checkValue={true}
            />

            {status == 'info' && (
              <>
                <div
                  className="modal-add-project__img-box"
                  onClick={(e) => setIsModalAddCover(true)}
                >
                  <img
                    className="img"
                    id="img"
                    src={currentCover ? currentCover : no_photo}
                    onError={(e) => (e.target.src = no_photo)}
                  />
                  <div className="modal-add-project__img-box_blackout">
                    <span>Изменить обложку</span>
                  </div>
                </div>

                <InputDinamycPlaceholder
                  onChange={(e) => setTitle(e)}
                  placeholder="Название проекта"
                  changeValue={title}
                  autoComplete={false}
                  onBlur={fetchAddNameProject}
                  size="s"
                  required
                />

                <TextareaDynamicPlaceholder
                  width="100%"
                  changeValue={description}
                  placeholder="Описание проекта"
                  onChange={setDescription}
                  onBlur={fetchAddDescriptionProject}
                />
              </>
            )}

            {status == 'exexutors' && (
              <div className="modal-add-project__content">
                <div className="executors">
                  <TitlePage
                    medium
                    title={'Автор:'}
                  />
                  <div className="executor-content">
                    <ExecutorPlaceholder
                      name={task ? authorName : infoProject?.author?.name}
                      color={task ? authorColor : infoProject?.author?.color}
                      email={task ? authorEmail : infoProject?.author?.login}
                      isShowInfo
                    />
                  </div>

                  <SelectExecutor
                    isShowInfo
                    onDeleteExecutor={fetchDeleteAttendeeProject}
                    onAddExecutor={fetchAddAttendeeProject}
                    executors={executors}
                    setExecutors={(e) => setExecutors(e)}
                    executorOptions={executorOptions}
                    multi
                    title="Участники проекта"
                    placeholder="Добавить участника"
                    author={infoProject?.author?.id}
                    isDeleteAuthor
                  />
                </div>
              </div>
            )}


            {status == 'fields' && (
              <div className="modal-add-project__fields-content">
                <TitlePage
                  medium
                  title={'Добавление полей'}
                />

                <div className="modal-add-project__request-list">

                  <div className="modal-add-project__fields-row">
                    <InputDinamycPlaceholder
                      changeValue={fieldsdName}
                      onChange={(e) => setFieldsName(e)}
                      placeholder="Введите название поля"
                      size="s"
                    />

                    <DropDownSelector
                      options_prop={TYPE_LIST}
                      state={selectedType}
                      setState={(e) => setSelectedType(e)}
                      placeholder="Тип поля"
                      isClearable={false}
                    />

                    <ButtonBasic
                      minWidth='210px'
                      blue
                      disabled={selectedType?.value !== 'dict'}
                      text='Настроить список'
                      onClick={(e) => {
                        setIsModalAddElementsDict(true)
                      }}
                    />

                    <ButtonBasic
                      green
                      width='auto'
                      text="Создать"
                      onClick={() => {
                        if (fieldsdName?.length > 0) {
                          addFields(fieldsdName);
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="modal-add-project__fields-group">
                  <TitlePage
                    medium
                    title={'Готовые поля'}
                  />

                  <div className="modal-add-project__fields-content">
                    <DynamicFormComponent
                      draggable
                      productTemporary={fields}
                      fetchDelete={fetchDeleteAdditionalFieldsProject}
                      fetchChange={fetchChangeAdditionalFieldsProject}
                      isEdit={true}
                    />
                  </div>
                </div>

              </div>
            )}

            {status == 'token' && <div
              className="modal-add-project__content"
            >
              <ButtonBasic
                blue
                text='Получить токен'
                onClick={() => {
                  fetchGetToken(projectId || selectedProject?.taskId)
                }}
              />
            </div>
            }

            {status == 'wiki' && <div className='modal-add-project__content'
              style={{
                flexDirection: 'column',
              }}
            >
              <TitlePage
                medium
                title={'Добавьте wiki к проекту'}
              />

              <DropDownSelector
                placeholder='Wiki'
                options_prop={wikiList}
                state={selectedWiki}
                setState={e => setSelectedWiki(e)}
                onBlur={fetchBindWiki}
              />
            </div>}
          </div>
        }

      />
    </>
  );
};

export { ModalAddProject };
